import { gql } from "@apollo/client"

export const REQUEST_LOGIN = gql`
    mutation requestLogin($email: String!) {
        requestLogin(input: { email: $email })
    }
`
